module.exports = __webpack_public_path__ + "static/img/91BM-062-StephenTsui.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-062-StephenTsui.jpg
// module id = IPyZ
// module chunks = 0